module.exports = __webpack_public_path__ + "static/media/checkbox-checked.e875c4b3.svg";